// extracted by mini-css-extract-plugin
module.exports = {"login":"Input_login__1OO0u","control":"Input_control__7JYPz","invalid":"Input_invalid__1XscM","actions":"Input_actions__Xyiys"};